import { render, staticRenderFns } from "./BugReport.vue?vue&type=template&id=6f715e52"
import script from "./BugReport.vue?vue&type=script&lang=js"
export * from "./BugReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports